import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Link from 'components/Link';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import s from './BreakingNews.scss';

class BreakingNews extends React.Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        link: PropTypes.string,
        title: PropTypes.string,
      }),
    ),
    theme: PropTypes.string,
    addWrapper: PropTypes.bool,
    withClose: PropTypes.bool,
    closeWidget: PropTypes.func,
    isMobile: PropTypes.bool,
  };
  static defaultProps = {
    data: undefined,
    theme: undefined,
    addWrapper: false,
    withClose: false,
    closeWidget: undefined,
    isMobile: false,
  };
  constructor(props) {
    super(props);

    const device = props.isMobile ? 'mobile' : 'desktop';
    const tickerControlStatus = props.data.length > 1 ? 'enable' : 'disable';
    this.tickerConatinerRef = React.createRef();
    this.state = {
      ticker_class: 'ticker__item',
      ticker_anim: 'no_anim',
      story: props.data[0].title || '',
      storyLink: props.data[0].link || '',
      CurrentStory: 0,
      tickerControlStatus,
      NumberOfStories: props.data.length || 0,
      StoriesArray: props.data || [],
      device,
      animation: 'playing',
      hide: false,
    };
  }
  componentDidMount() {
    this.startAnimation();
  }
  startAnimation() {
    this.clearAllAnimations();
    const { StoriesArray, NumberOfStories, device, animation } = this.state;
    let { CurrentStory } = this.state;
    let CurrentStoryTime = 10000;
    if (CurrentStory < 0 || CurrentStory >= NumberOfStories) {
      this.setState({ CurrentStory: 0 });
      CurrentStory = 0;
    }
    this.setState({
      story: StoriesArray[CurrentStory].title,
      storyLink: StoriesArray[CurrentStory].link,
    });
    const timePixel = this.isIE() ? 40 : 40; //fix for ie descreasing speed for right animation
    CurrentStoryTime = StoriesArray[CurrentStory].title.length * 50 + 4000;
    if (device === 'desktop') {
      this.timeout_length_call = setTimeout(() => {
        this.IncreasewidthAnimation(0, timePixel); //init width of component to 0 and increase a pixel after 4 millisecond
      }, 0);
      if (CurrentStoryTime >= 5000) {
        this.timeout_addAnimation = setTimeout(() => {
          this.setState({ ticker_anim: 'add_anim_ticker' });
        }, 4000);
      }
    }
    if (animation === 'playing') {
      this.loadNextStry(CurrentStory, CurrentStoryTime);
    }
  }
  isIE = () => {
    if (
      document.documentMode ||
      /Edge/.test(navigator.userAgent) ||
      navigator.userAgent.indexOf('Trident') > -1
    ) {
      return true;
    }
    return false;
  };
  loadNextStry(CurrentStory, CurrentStoryTime) {
    this.timeout_news = setTimeout(() => {
      this.setState({ CurrentStory: CurrentStory + 1 }, () => {
        this.startAnimation();
      });
    }, CurrentStoryTime);
  }
  nextBreakingNews = e => {
    if (this.state.CurrentStory + 1 <= this.state.NumberOfStories - 1) {
      e.preventDefault();
      this.setState({ CurrentStory: this.state.CurrentStory + 1 }, () => {
        this.callAnimation();
      });
    }
  };
  prevBreakingNews = e => {
    if (this.state.CurrentStory > 0) {
      e.preventDefault();
      this.setState({ CurrentStory: this.state.CurrentStory - 1 }, () => {
        this.callAnimation();
      });
    }
  };
  pauseBreakingNews = e => {
    if (this.state.tickerControlStatus === 'enable') {
      e.preventDefault();
      //this.setState({ ticker_anim: 'no_anim' });
      if (this.timeout_news) {
        clearTimeout(this.timeout_news); //kill the next breaking
      }
      if (this.timeout_addAnimation) {
        clearTimeout(this.timeout_addAnimation); //arfer 5 seconds marque left animation
      }
      this.setState({ animation: 'paused' });
    }
  };
  callAnimation = () => {
    if (this.state.tickerControlStatus === 'enable') {
      //if single news tickercontrolstatus is disabled
      this.startAnimation();
    }
  };
  playBreakingNews = e => {
    e.preventDefault();
    this.setState({ animation: 'playing' }, () => {
      this.callAnimation();
    });
  };
  IncreasewidthAnimation = (storyWidth, time) => {
    const storyWidthvar = storyWidth + 6;
    if (this.tickerConatinerRef && this.tickerConatinerRef.current) {
      this.tickerConatinerRef.current.style.width = `${storyWidthvar}px`;
    }
    this.timeout_length = setTimeout(() => {
      this.IncreasewidthAnimation(storyWidthvar, time);
    }, time);
  };
  clearAllAnimations = () => {
    this.setState({ ticker_anim: 'no_anim' });
    if (this.timeout_addAnimation) {
      clearTimeout(this.timeout_addAnimation);
    }
    if (this.timeout_length) {
      clearTimeout(this.timeout_length);
    }
    if (this.timeout_length_call) {
      clearTimeout(this.timeout_length_call);
    }
    if (this.timeout_news) {
      clearTimeout(this.timeout_news);
    }
  };

  hideBreakingNews = () => {
    this.setState({ hide: true });
  };

  closeWidget = e => {
    this.props.closeWidget(e);
    sendGaThroughProps({
      data: {
        gaCategory: 'ATF_breaking_news_bar',
        gaAction: 'click',
        gaLabel: 'close_icon',
      },
    });
  };

  render() {
    const { data, addWrapper, isMobile } = this.props;
    if (data) {
      const TickerClassName = `${s[this.state.ticker_class]} ${
        s[this.state.ticker_anim]
      }`;
      const tickerControlStatus = `${s[this.state.tickerControlStatus]}`;
      const statePrevButton =
        this.state.CurrentStory === 0 ? 'disable' : 'enable';
      const stateNextButton =
        this.state.CurrentStory === this.state.NumberOfStories - 1
          ? 'disable'
          : 'enable';
      //enable or disable ticker controls based on single or multiple news
      let buttonPlay;
      let newsItem;
      if (this.state.storyLink) {
        newsItem = (
          <Link
            to={this.state.storyLink}
            data-ga={`ATF_breaking_news_bar|title_click|${
              this.state.storyLink
            }`}
          >
            {this.state.story}
          </Link>
          // <a href={`${this.state.storyLink}`}>{`${this.state.story}`}</a>
          //if link make anchor
        );
      } else {
        newsItem = `${this.state.story}`;
      }
      if (this.state.animation === 'playing') {
        //if animation playing show pause button
        buttonPlay = (
          <li
            className={`${s['jnt-play-pause']}`}
            onClick={this.pauseBreakingNews}
          >
            <button href="" />
          </li>
        );
      } else {
        //if animation paused show play button
        buttonPlay = (
          <li
            className={`${s['jnt-play-pause']} ${s.paused}`}
            onClick={this.playBreakingNews}
          >
            <button />
          </li>
        );
      }
      const wrapperClassname = classnames({
        [`${s['breaking-news']}`]: true,
        contentwrapper: !addWrapper,
        [`${s.wrapper}`]: addWrapper,
        [`${s[this.state.device]}`]: true,
        [`${s.hide}`]: this.state.hide,
        [`${s.red_theme}`]: this.props.theme === 'redTheme',
      });
      const component = (
        <React.Fragment>
          <div className={s['ticker-title']}>
            <span>
              Breaking <span> News</span>
            </span>
          </div>
          {isMobile && (
            <div
              className={`${s.newsskip}`}
              onClick={() => this.hideBreakingNews()}
            >
              <i />
            </div>
          )}

          <div className={s['ticker-wrap']}>
            <div className={`${s.ticker}`}>
              <div
                className={`${TickerClassName}`}
                ref={this.tickerConatinerRef}
              >
                {newsItem}
              </div>
            </div>
          </div>
          <ul className={`${s['ticker-controls']}  ${tickerControlStatus}`}>
            <li className={`${s['jnt-prev']}  ${s[`${statePrevButton}`]}`}>
              <button onClick={this.prevBreakingNews} />
            </li>
            {buttonPlay}
            <li className={`${s['jnt-next']} ${s[`${stateNextButton}`]}`}>
              <button onClick={this.nextBreakingNews} />
            </li>
          </ul>
          {this.props.withClose &&
            this.props.closeWidget && (
              <button
                className={s.closeicon}
                onClick={e => this.closeWidget(e)}
              >
                +
              </button>
            )}
        </React.Fragment>
      );
      return (
        <div className={wrapperClassname}>
          {addWrapper ? (
            <div className="contentwrapper">{component}</div>
          ) : (
            <React.Fragment>{component}</React.Fragment>
          )}
        </div>
      );
    }
    return <div />;
  }
}

export default BreakingNews;
